import { getPath } from '@/router/common'

const baseUrl = {
  title: '出入库批次',
  path: 'StorageManage77838'
}

export default [
  {
    path: getPath('InStorage', baseUrl),
    name: 'StorageManage77838_InStorage',
    component: () => import(/* webpackChunkName: "StorageManage77838_InStorage" */ '@/views/storageManage77838/inStorage/index.vue'),
    meta: {
      title: '入库记录'
    }
  },
  {
    path: getPath('OutStorage', baseUrl),
    name: 'StorageManage77838_OutStorage',
    component: () => import(/* webpackChunkName: "StorageManage77838_OutStorage" */ '@/views/storageManage77838/outStorage/index.vue'),
    meta: {
      title: '出库记录'
    }
  },
  {
    path: getPath('ZxStorage', baseUrl),
    name: 'StorageManage77838_ZxStorage',
    component: () => import(/* webpackChunkName: "StorageManage77838_ZxStorage" */ '@/views/storageManage77838/zxStorage/index.vue'),
    meta: {
      title: '运单大全'
    }
  },
  {
    path: getPath('AddInStorage', baseUrl),
    name: 'StorageManage77838_AddInStorage',
    component: () => import(/* webpackChunkName: "StorageManage77838_AddInStorage" */ '@/views/storageManage77838/addInStorage/index.vue'),
    meta: {
      title: '新增修改入库记录'
    }
  },
  {
    path: getPath('InStorageDetail', baseUrl),
    name: 'StorageManage77838_InStorageDetail',
    component: () => import(/* webpackChunkName: "StorageManage77838_InStorageDetail" */ '@/views/storageManage77838/inStorageDetail/index.vue'),
    meta: {
      title: '查看入库记录详情'
    }
  },
  {
    path: getPath('AddOutStorage', baseUrl),
    name: 'StorageManage77838_AddOutStorage',
    component: () => import(/* webpackChunkName: "StorageManage77838_AddOutStorage" */ '@/views/storageManage77838/addOutStorage/index.vue'),
    meta: {
      title: '新增修改出库记录'
    }
  },
  {
    path: getPath('AddZxStorage', baseUrl),
    name: 'StorageManage77838_AddZxStorage',
    component: () => import(/* webpackChunkName: "StorageManage77838_AddZxStorage" */ '@/views/storageManage77838/addZxStorage/index.vue'),
    meta: {
      title: '新增修改装卸记录'
    }
  }
]
